import { AxiosError } from 'axios';

export interface ApiError {
  message: string;
  status?: number;
  code?: string;
}

export const extractErrorMessage = (error: any): string => {
  if (error instanceof AxiosError) {
    // Check if the error has a response with data
    if (error.response?.data) {
      const responseData = error.response.data;
      
      // Handle different error response formats
      if (typeof responseData === 'string') {
        return responseData;
      }
      
      if (typeof responseData === 'object') {
        // Check for common error message fields
        if (responseData.message) {
          return responseData.message;
        }
        if (responseData.error) {
          return responseData.error;
        }
        if (responseData.detail) {
          return responseData.detail;
        }
        if (responseData.errorMessage) {
          return responseData.errorMessage;
        }
      }
    }
    
    // Handle HTTP status codes
    switch (error.response?.status) {
      case 400:
        return 'Bad request. Please check your input and try again.';
      case 401:
        return 'Unauthorized. Please login again.';
      case 403:
        return 'Access denied. You do not have permission to perform this action.';
      case 404:
        return 'Resource not found.';
      case 409:
        return 'Conflict. The resource already exists or is in an invalid state.';
      case 422:
        return 'Validation error. Please check your input.';
      case 429:
        return 'Too many requests. Please try again later.';
      case 500:
        return 'Internal server error. Please try again later.';
      case 502:
        return 'Bad gateway. Please try again later.';
      case 503:
        return 'Service unavailable. Please try again later.';
      default:
        return 'An unexpected error occurred. Please try again.';
    }
  }
  
  // Handle non-Axios errors
  if (error instanceof Error) {
    return error.message;
  }
  
  if (typeof error === 'string') {
    return error;
  }
  
  return 'An unexpected error occurred. Please try again.';
};

export const isNetworkError = (error: any): boolean => {
  if (error instanceof AxiosError) {
    return !error.response;
  }
  return false;
};

export const isAuthError = (error: any): boolean => {
  if (error instanceof AxiosError) {
    return error.response?.status === 401 || error.response?.status === 403;
  }
  return false;
};

export const isValidationError = (error: any): boolean => {
  if (error instanceof AxiosError) {
    return error.response?.status === 400 || error.response?.status === 422;
  }
  return false;
}; 